import * as log from 'loglevel';
import * as _ from "lodash"
import * as ko from 'knockout';
import {ComputedOptions} from "~knockout/index";
import {getPrimaryScreenVisibilityOptions} from "../ScreenVisibility";
import {Screen} from "../Screen";
import {showPrimaryScreen} from "../ScreenManager";
import {playSound, toggleMute} from '../../game/audio/AudioManager';
import {Observable} from '~knockout/index';

var template = require('./MainMenuScreen.html');

class MainMenuScreenComponent extends Screen
{
    isMuted:  Observable<boolean>;


    /**
     * create knockout bindings
     */
    createBindings()
    {
        //  create super-class bindings

        super.createBindings();

        this.isMuted = ko.observable(false);
    }


    /**
     * get screen visibility computed options
     * @returns {ComputedOptions<boolean>}
     */
    getVisibleOptions() : ComputedOptions<boolean>
    {
        return getPrimaryScreenVisibilityOptions('main-menu');
    }


    /**
     * show the leaderboard screen
     */
    showLeaderboard()
    {
        showPrimaryScreen('leaderboard');
    }


    /**
     * show the instructions screen
     */
    showInstructions()
    {
        showPrimaryScreen('instructions');

    }


    /**
     * show the gameplay screen and start playing
     */
    startGame()
    {
        showPrimaryScreen('gameplay');

        //  play a button sound

        playSound('button-click');
    }

    /**
     * show the menu, pausing the game
     */
    toggleAudio()
    {
        this.isMuted(toggleMute());
    }


    /**
     * call a function when we show
     */
    onShow()
    {
        document.getElementById('edf-power-patrol-embed').style.height = window.innerHeight + 'px';

        //  animate the screen in

        var timeline: TimelineMax;

        timeline = new TimelineMax();

        timeline.fromTo('.main-menu__bulbs', 2, { top: '-100%' }, { top: '0px', ease: Expo.easeOut }, 0.5);
        timeline.fromTo('.main-menu__logo', 0.5, { scale: 0.1, opacity: 0 }, { scale: 1, opacity: 1, ease: Back.easeOut, easeParams: [1.4] }, 1);
        timeline.fromTo('.zingy__main-menu', 1, { bottom: '-100%', right: '-150px' }, { bottom: '-60px', right: '-110px', ease: Expo.easeOut }, 1.25);
        timeline.fromTo('.main-menu__skateboard', 1, { bottom: '-100%', left: '-150px' }, { bottom: '0px', left: '0px', ease: Expo.easeOut }, 1.4);
        //timeline.fromTo('.pp-main-menu__edu-logo', 1, { top: '-50%' }, { top: '0%', ease: Expo.easeOut }, 1.6);
        timeline.fromTo('.intro-buttons', 1, { bottom: '-20%' }, { bottom: '10%', ease: Back.easeOut }, 2);
    }
}



/**
 * register this component with knockout
 * @param vizID
 */
export function registerMainMenuScreenComponent()
{
    ko.components.register('pp-main-menu',
        {
            viewModel: () => { return new MainMenuScreenComponent() },
            template: template
        });
}


// WEBPACK FOOTER //
// ./src/ts/screens/main-menu/MainMenuScreen.ts